<!--
	引用方法:
	在需要的组件中
	this.$store.dispatch('showMsgModal',{
    	autoClose:true,
    	info:'搜索内容不能为空'
    })

 -->

<template>
	<transition name="fade">
	<div class="modal-box">
		<div class="context" @click="closeModal"></div>
		<div class="modal">
			<div class="modal-title">消息提示<span class="modal-close" @click="closeModal">
				<!-- <img src="../../assets/images/common/x.png"> -->
				</span></div>
			<div class="modal-content">{{text}}</div>
		</div>
	</div>
	</transition>
</template>

<script>
	export default {
		name:'MsgModal',
		props:['text'],
		data () {
			return {

			}
		},
		methods: {
			closeModal () {
      	// this.$store.commit('showMsgModal', false);
      }
		}
	}
</script>

<style scoped lang="scss">
  @import '../../assets/scss/base.scss';
.modal-box,
.context{
	height: 100%;
	width: 100%;
	position: fixed;
	left: 0;
	z-index: 99999;
	top: 0;
}
.context{
	background-color: rgba(0,0,0,0.5);
}
.modal{
  position: absolute;
  min-height: 250px;
  width: 440px;
  left:50%;
  top:40%;
  z-index: 99999999;
  transform: translate(-50%,-50%);
  background-color: #ffffff;
  border-radius: 8px;
  font-size: 14px;
}
.modal-title{
	height: 40px;
	line-height: 40px;
	background-color: $reminder-border;
	color:#fff;
	padding-top: 1px;
	margin-top: -1px;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	text-align: center;
	position: relative;
}
.modal-close{
	position: absolute;
	right: 12px;
	top: 13px;
	width: 12px;
	height: 12px;
	display: block;
	text-align: center;
	cursor: pointer;
}
.modal-close img{
	width: 100%;
}
.modal-content{
	min-height: 150px;
    padding: 85px 18px;
    text-align: center;
	font-size: 20px;
}
/*transition Start*/
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}
/*transition End*/
</style>
